import { Stack, Tab, Tabs } from '@all-manager/design-system-v2';
import FullPageLayout from '../../../../layout/FullPageLayout/FullPageLayout';
import DocumentIndexingSettingsCard from '../../../documents/components/DocumentIndexingSettingsCard/DocumentIndexingSettingsCard';
import DocumentTypesSettingsCard from '../../../documents/components/DocumentTypesSettingsCard/DocumentTypesSettingsCard';
import GoogleDriveCard from '../../../google-drive/components/GoogleDriveCard/GoogleDriveCard';
import AiSettingsCard from '../../components/AiSettingsCard/AiSettingsCard';
import AiUsageCard from '../../components/AiUsageCard/AiUsageCard';
import MembersCard from '../../components/MembersCard/MembersCard';
import SpaceInfoCard from '../../components/SpaceInfoCard/SpaceInfoCard';
import useSpaceSettingsPage from './useSpaceSettingsPage';

export default function SpaceSettingsPage() {
  const hook = useSpaceSettingsPage();

  if (!hook.currentSpace) return null;

  return (
    <FullPageLayout htmlTitle="Paramètres" title="Paramètres">
      <Stack spacing={3}>
        <Tabs
          divider
          value={hook.activeSection}
          onChange={hook.handleSectionChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="Sections des paramètres"
        >
          <Tab value="copropriete" label="Ma copropriété" />
          <Tab value="document-types" label="Types de documents" />
          <Tab value="google-drive" label="Google Drive" />
          <Tab value="intelligence-artificielle" label="Intelligence artificielle" />
          <Tab value="indexation" label="Indexation des documents" />
        </Tabs>

        {hook.activeSection === 'copropriete' ? (
          <>
            <SpaceInfoCard space={hook.currentSpace} isAdmin={hook.isAdmin} />
            <MembersCard spaceId={hook.currentSpace.id} isAdmin={hook.isAdmin} />
          </>
        ) : null}

        {hook.activeSection === 'document-types' ? (
          <DocumentTypesSettingsCard spaceId={hook.currentSpace.id} isAdmin={hook.isAdmin} />
        ) : null}

        {hook.activeSection === 'google-drive' ? <GoogleDriveCard /> : null}

        {hook.activeSection === 'intelligence-artificielle' ? (
          <>
            <AiSettingsCard spaceId={hook.currentSpace.id} />
            <AiUsageCard spaceId={hook.currentSpace.id} />
          </>
        ) : null}

        {hook.activeSection === 'indexation' ? (
          <DocumentIndexingSettingsCard spaceId={hook.currentSpace.id} />
        ) : null}
      </Stack>
    </FullPageLayout>
  );
}

